export default __webpack_public_path__ + "static/media/profile-img.5179e446.png";